import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, Autocomplete, TextField } from '@mui/material';
import { fetchOptions } from '../queries';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';
import { parseDropoffAmount } from '../../../../main/apps/ConfiguredApps/silo-invoices/SiloInvoicesTable.helpers';

export const getSiloReferenceId = (reference) => {
    if (typeof reference === 'string') return reference;
    if (reference != null && typeof reference === 'object') return reference._id || reference.id || null;
    return null;
};

const SiloInvoiceDropoff = ({ name, query, props, user, filterRef }) => {
    const classes = useReactHookFormStyles();
    const {
        control,
        formState: { errors },
        getValues,
        selectedValues,
        updateSelectedValues,
        watch,
    } = useFormContext();
    const [options, setOptions] = useState([]);

    const {
        label,
        rules,
        variant,
        disabled,
        defaultValue,
        required,
        shouldUnregister, // Field should unregister if no longer rendered
    } = props;

    const { endpoint } = query;
    const { referenceField } = filterRef || {};

    useEffect(
        () => {
            const referenceId = getSiloReferenceId(referenceField && selectedValues[referenceField]);

            const getOptions = async () => {
                const optionsResponse = await fetchOptions({ endpoint: `${endpoint}/${referenceId}`, user });
                if (optionsResponse.error) {
                    setOptions([]);
                } else {
                    const existingValue = getValues(name);
                    if (props.multiple) {
                        setOptions([...optionsResponse, ...existingValue]);
                    } else {
                        setOptions(optionsResponse);
                    }
                }
            };

            if (referenceId != null) {
                getOptions();
            } else {
                setOptions([]);
            }
        },
        !!referenceField ? [watch(referenceField), user, getSiloReferenceId(referenceField && selectedValues[referenceField])] : [user]
    );

    const handleChange = (item, onChange) => {
        updateSelectedValues(name, item);
        // Want entire object, not just id
        // Need to split dropoffs/IPDOs on submit
        onChange(item);
    };

    const renderInput = (renderProps) => (
        <TextField
            {...renderProps}
            label={label}
            required={required}
            variant={variant || 'outlined'}
            error={errors[name]}
            helperText={errors[name]?.message}
            // wrap
        />
    );

    const getOptionLabel = (option) => {
        let parsedLabel = '';
        if (option?.route_session_id?.BOL) parsedLabel = option?.route_session_id?.BOL;
        if (option?.lt_number && !parsedLabel.route_session_id?.BOL) parsedLabel = option?.lt_number;
        const optionAmount = parseDropoffAmount(option, getValues('silo_id'));
        if (optionAmount) parsedLabel = `${parsedLabel} - ${optionAmount.toLocaleString()} lbs`;
        return parsedLabel;
    };

    return (
        <FormControl className={classes.formController}>
            <Controller
                name={name}
                control={control}
                rules={rules}
                defaultValue={defaultValue}
                shouldUnregister={shouldUnregister}
                render={({ field: { onChange, value } }) => (
                    <Autocomplete
                        {...props}
                        value={value || null}
                        onChange={(e, item) => handleChange(item, onChange)}
                        options={options}
                        disabled={disabled}
                        renderInput={renderInput}
                        getOptionLabel={getOptionLabel}
                        // wrap
                    />
                )}
            />
        </FormControl>
    );
};

export default SiloInvoiceDropoff;
